import { render, staticRenderFns } from "./ViewSales.vue?vue&type=template&id=5e245b46&scoped=true&"
import script from "./ViewSales.vue?vue&type=script&lang=js&"
export * from "./ViewSales.vue?vue&type=script&lang=js&"
import style0 from "./ViewSales.vue?vue&type=style&index=0&id=5e245b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e245b46",
  null
  
)

export default component.exports